// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f0d890be","455":"5fac2397"}[chunkId] + ".chunk.js";
};